import { apiBaseUrl } from '../../core/globalVariables';

import React, { useEffect, useState } from 'react';
import { RiCheckboxCircleFill } from "react-icons/ri";
import BarLoader from "react-spinners/BarLoader";

const LoadMenuModal = ({
  selectedFirstPrivateMapParentRef,
  isMenuLoadClick,
  closeLoadMenu,
  globalRefs,
  globalState,
  setLoadedPercentage,
  resetLeftSubMenu,
  workingLocally,
  devDeployment
}) => {

  const [mapData, setMapData] = useState([]);
  const [clickedMapIdPublic, setClickedMapIdPublic] = useState(null);
  const [isLoadingMaps, setIsLoadingMaps] = useState(false);
  const [activeTab, setActiveTab] = useState('private');
  const [privateMapData, setPrivateMapData] = useState(false);

  const mapRef = globalRefs.mapRef;

  const setIsLoading = globalState.setIsLoading;
  const setisMenuLoadClick = globalState.setisMenuLoadClick;

  const clickedMapId = globalState.clickedMapId;
  const setClickedMapId = globalState.setClickedMapId;

  const setClickedMapIDtoLoad = globalState.setClickedMapIDtoLoad;
  const clickedMapIDtoLoad = globalState.clickedMapIDtoLoad;

  const setSelectedMetric = globalState.setSelectedMetric;
  const setSelectedKey = globalState.setSelectedKey;

  const userID = globalState.userID;

  const setGlobalPublicSelectedDataset =
    globalState.setGlobalPublicSelectedDataset;

  const globalPublicSelectedDataset =
    globalState.globalPublicSelectedDataset;

  const setisLeftSubDrawerOpen =
    globalState.setisLeftSubDrawerOpen;

  const setisComparing =
    globalState.setisComparing;

  const setIs2DViewActive =
    globalState.setIs2DViewActive;

  const publicMapsFromAPI = mapData.filter(
    (map) => map.public === true
  );

  const privateMaps = mapData.filter(
    (map) =>
      map.public !== true &&
      (!map.realms || map.realms.length === 0)
  );

  const apiMaps = mapData.filter(
    (map) =>
      map.public !== true &&
      map.realms &&
      map.realms.length > 0
  );

  // --------------------------------------------------
  // OAuth LOGIN
  // --------------------------------------------------

  const goToLogin = async () => {

    const codeVerifier =
      crypto.randomUUID() + crypto.randomUUID();

    const hash = await crypto.subtle.digest(
      'SHA-256',
      new TextEncoder().encode(codeVerifier)
    );

    const codeChallenge = btoa(
      String.fromCharCode(...new Uint8Array(hash))
    )
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');

    const state = crypto.randomUUID();

    sessionStorage.setItem(
      'oauth_code_verifier',
      codeVerifier
    );

    sessionStorage.setItem(
      'oauth_state',
      state
    );

    const params = new URLSearchParams({
      response_type: 'code',
      client_id: 'skylark',

      redirect_uri: workingLocally
        ? 'http://localhost:3000/callback'
        : devDeployment
          ? 'http://dev.harrier.land/callback'
          : 'http://map.harrier.land/callback',

      code_challenge: codeChallenge,
      code_challenge_method: 'S256',
      state,
    });

    window.location.href =
      `${apiBaseUrl}/oauth/authorize?${params}`;
  };

  // --------------------------------------------------
  // FETCH ALL MAPS
  // --------------------------------------------------

  useEffect(() => {

    if (!isMenuLoadClick) {
      return;
    }

    setIsLoadingMaps(true);

    const fetchAllMapDataForLoadMenu = async () => {

      try {

        const token = localStorage.getItem('token');

        if (!token) {
          throw new Error('No token in local storage');
        }

        const response = await fetch(
          `${apiBaseUrl}/api/maps`,
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (!response.ok) {

          const errorText = await response.text();

          throw new Error(
            `Map request failed: ${response.status} ${errorText}`
          );
        }

        const data = await response.json();

        data.sort(
          (a, b) => new Date(b.modified) - new Date(a.modified)
        );

        console.log('Maps:', data);

        console.log('Maps:', data);

        // Remove Demo Map
        for (let i = 0; i < data.length; i++) {

          if (data[i].title === "Demo Map") {

            data.splice(i, 1);

            break;
          }
        }

        setMapData(data);

      } catch (error) {

        console.error(
          'Error fetching map data:',
          error
        );

        setMapData([]);

      } finally {

        setIsLoadingMaps(false);
      }
    };

    fetchAllMapDataForLoadMenu();

  }, [isMenuLoadClick]);

  // --------------------------------------------------
  // DETERMINE WHETHER PRIVATE MAPS EXIST
  // --------------------------------------------------

  useEffect(() => {

    setPrivateMapData(
      privateMaps.length > 0
    );

  }, [privateMaps]);

  // --------------------------------------------------
  // LOAD SELECTED MAP
  // --------------------------------------------------

  const loadDataBtn = () => {

    resetLeftSubMenu();

    setisLeftSubDrawerOpen(false);

    setisComparing(false);

    setIs2DViewActive(false);

    setGlobalPublicSelectedDataset(null);

    setClickedMapIDtoLoad(clickedMapId);

    setClickedMapIdPublic(null);

    setIsLoading(true);

    setisMenuLoadClick(false);

    setClickedMapId(null);
  };

  const handlePublicOptionClick = (value) => {

    console.log(value);

    setClickedMapIdPublic(value);
  };

  const selectedFirstPrivateMap = () => {

    if (mapData && mapData.length > 0) {

      const firstMapId = mapData[0].id;

      setClickedMapId(firstMapId);
    }
  };

  useEffect(() => {

    selectedFirstPrivateMapParentRef.current =
      selectedFirstPrivateMap;

  }, [mapData]);

  // --------------------------------------------------
  // RENDER
  // --------------------------------------------------

  return isMenuLoadClick ? (

    <div className='file_dropdown_list'>

      <div className='APIMapLoad'>

        <div className="closeBtnCont">

          <span
            className="closeLoadBtn"
            onClick={closeLoadMenu}
          >
            Cancel
          </span>

          <span
            className="openLoadBtn"
            onClick={loadDataBtn}
          >
            Open
          </span>

        </div>

        <div className='APIMapLoadInnter'>

          <div className='public-private-toggle three-way'>

            <button
              className={`toggle-btn-left ${activeTab === 'private'
                ? 'active'
                : ''
                }`}
              onClick={() => setActiveTab('private')}
            >
              Private
            </button>

            <button
              className={`toggle-btn-middle ${activeTab === 'api'
                ? 'active'
                : ''
                }`}
              onClick={() => setActiveTab('api')}
            >
              API
            </button>

            <button
              className={`toggle-btn-right ${activeTab === 'public'
                ? 'active'
                : ''
                }`}
              onClick={() => setActiveTab('public')}
            >
              Public
            </button>

          </div>

          {/* ---------------- TAB CONTENT ---------------- */}

          {isLoadingMaps && (

            <div className="loadingThumbnails">

              Loading Maps

              <div className="loadingThumbnailsSpinner">

                <BarLoader />

              </div>

            </div>

          )}

          {/* PUBLIC */}

          {!isLoadingMaps &&
            activeTab === 'public' && (

              <ul className='map-list'>

                {publicMapsFromAPI.map((map) => {

                  const createdDate =
                    new Date(map.created)
                      .toLocaleString();

                  const modifiedDate =
                    new Date(map.modified)
                      .toLocaleString();

                  const isCurrentMap =
                    clickedMapIDtoLoad === map.id;

                  return (

                    <li
                      key={map.id}
                      onClick={() => {

                        if (!isCurrentMap) {
                          setClickedMapId(map.id);
                        }

                      }}
                      className={`map-item ${clickedMapId === map.id
                        ? 'highlighted'
                        : ''
                        } ${isCurrentMap
                          ? 'disabled-map-item'
                          : ''
                        }`}
                    >

                      <div className="map-info">

                        <div className="map-title">
                          {map.title}
                        </div>

                        <div className="map-meta">

                          <span>
                            <strong>Created:</strong>{' '}
                            {createdDate}
                          </span>

                          <span>
                            <strong>Modified:</strong>{' '}
                            {modifiedDate}
                          </span>

                        </div>

                      </div>

                      {isCurrentMap && (

                        <span
                          style={{
                            marginLeft: '20px',
                            fontSize: '18px',
                            color: '#29645D',
                            marginTop: '7.5px'
                          }}
                          className="current-map-badge"
                        >
                          <RiCheckboxCircleFill />
                        </span>

                      )}

                    </li>

                  );

                })}

              </ul>

            )}

          {/* API */}

          {!isLoadingMaps &&
            activeTab === 'api' && (

              !privateMapData ? (

                <>

                  <div
                    className="noMapsMessage"
                    style={{
                      position: 'absolute',
                      top: '175px',
                      bottom: '10px',
                      color: '#AAAAAB',
                      left: '50%',
                      transform: 'translateX(-50%)',
                    }}
                  >
                    Please Sign In to view your API Maps.
                  </div>

                  <div
                    className='loadMenuAuthButton'
                    onClick={goToLogin}
                  >
                    <p>Sign in</p>
                  </div>

                </>

              ) : (

                <ul className="map-list">

                  {apiMaps.map((map) => {

                    const createdDate =
                      new Date(map.created)
                        .toLocaleString();

                    const modifiedDate =
                      new Date(map.modified)
                        .toLocaleString();

                    const isCurrentMap =
                      clickedMapIDtoLoad === map.id;

                    return (

                      <li
                        key={map.id}
                        onClick={() => {

                          if (!isCurrentMap) {
                            setClickedMapId(map.id);
                          }

                        }}
                        className={`map-item ${clickedMapId === map.id
                          ? 'highlighted'
                          : ''
                          } ${isCurrentMap
                            ? 'disabled-map-item'
                            : ''
                          }`}
                      >

                        <div className="map-info">

                          <div className="map-title">

                            {map.title}

                            <span className="realm-tag">
                              API Origin:{' '}
                              {map.realms.join(', ')}
                            </span>

                          </div>

                          <div className="map-meta">

                            <span>
                              <strong>Created:</strong>{' '}
                              {createdDate}
                            </span>

                            <span>
                              <strong>Modified:</strong>{' '}
                              {modifiedDate}
                            </span>

                          </div>

                        </div>

                        {isCurrentMap && (

                          <span
                            style={{
                              marginLeft: '20px',
                              fontSize: '18px',
                              color: '#29645D',
                              marginTop: '7.5px'
                            }}
                            className="current-map-badge"
                          >
                            <RiCheckboxCircleFill />
                          </span>

                        )}

                      </li>

                    );

                  })}

                </ul>

              )

            )}

          {/* PRIVATE */}

          {!isLoadingMaps &&
            activeTab === 'private' && (

              !privateMapData ? (

                <>

                  <div
                    className="noMapsMessage"
                    style={{
                      position: 'absolute',
                      top: '175px',
                      bottom: '10px',
                      color: '#AAAAAB',
                      left: '50%',
                      transform: 'translateX(-50%)',
                    }}
                  >
                    Please Sign In to view your Private Maps.
                  </div>

                  <div
                    className='loadMenuAuthButton'
                    onClick={goToLogin}
                  >
                    <p>Sign in</p>
                  </div>

                </>

              ) : (

                <ul className="map-list">

                  {privateMaps.map((map) => {

                    const createdDate =
                      new Date(map.created)
                        .toLocaleString();

                    const modifiedDate =
                      new Date(map.modified)
                        .toLocaleString();

                    const isCurrentMap =
                      clickedMapIDtoLoad === map.id;

                    return (

                      <li
                        key={map.id}
                        onClick={() => {

                          if (!isCurrentMap) {
                            setClickedMapId(map.id);
                          }

                        }}
                        className={`map-item ${clickedMapId === map.id
                          ? 'highlighted'
                          : ''
                          } ${isCurrentMap
                            ? 'disabled-map-item'
                            : ''
                          }`}
                      >

                        <div className="map-info">

                          <div className="map-title">
                            {map.title}
                          </div>

                          <div className="map-meta">

                            <span>
                              <strong>Created:</strong>{' '}
                              {createdDate}
                            </span>

                            <span>
                              <strong>Modified:</strong>{' '}
                              {modifiedDate}
                            </span>

                          </div>

                        </div>

                        {isCurrentMap && (

                          <span
                            style={{
                              marginLeft: '20px',
                              fontSize: '18px',
                              color: '#29645D',
                              marginTop: '7.5px'
                            }}
                            className="current-map-badge"
                          >
                            <RiCheckboxCircleFill />
                          </span>

                        )}

                      </li>

                    );

                  })}

                </ul>

              )

            )}

          {/* --------------------------------------------- */}

        </div>

      </div>

    </div>

  ) : null;
};

export default LoadMenuModal;